export const engineers = state => state.engineers;
export const engineersLoadInProgress = state => state.engineers === null;
export const engineerSearchInProgress = state =>
  state.engineerSearchResults === null;
export const foundEngineers = state => state.engineerSearchResults;

export const engineer = state => state.engineer;
export const isEngineerLoading = state => state.engineer === null;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/engineers.js